export default __webpack_public_path__ + "static/media/Share.8162df65.svg";